import { JSON, RADIUS, TOP } from "@constants/index";

export const azureMapConfig = {
  location: {
    azureMapKey: process.env.NEXT_PUBLIC_AZURE_MAP_KEY,
      azureGeoJson : process.env.NEXT_PUBLIC_AZURE_GEOJSON
  },
  spatial: {
    base_url: '',
    azureMapKey: process.env.NEXT_PUBLIC_AZURE_MAP_KEY,
    format: JSON,
    top: TOP,
    radius: RADIUS
  }
};
